<div class="menubar-hoverable header-fixed menubar-pin admission-enquiry-page">
  <div id="base">
    <div class="offcanvas"></div>
    <div id="content">
      <section class="admission-enquiry-body">

  <div class="page-header-row">
    <div class="page-header-text">
      <h1 class="page-title">{{ 'admissionEnquiryPage.pageTitle' | translate }}</h1>
      <p class="page-subtitle">{{ 'admissionEnquiryPage.pageSubtitle' | translate }}</p>
    </div>
    <div class="header-actions">
      <select class="native-select academic-year-select" [(ngModel)]="selectedAcademicYearId"
        (ngModelChange)="onAcademicYearChange()">
        <option *ngFor="let year of academicYears" [value]="year.id">
          {{ year.label }}<ng-container *ngIf="year.isCurrent"> {{ 'admissionEnquiryPage.current' | translate }}</ng-container>
        </option>
      </select>
      <button class="btn-new-enquiry" (click)="openNewEnquiryModal()" *ngIf="permissions.ADMISSION_ENQUIRY_ADD_AND_MANAGE == 'ENABLED'">
        <i class="ri-add-line"></i>
        {{ 'admissionEnquiryPage.newEnquiry' | translate }}
      </button>
    </div>
  </div>

  <div class="stats-row-wrap">
    <div class="stats-row">
      <ng-container *ngIf="!loadingEnquiries">
        <div class="stat-card" *ngFor="let stat of displayStats" [ngClass]="stat.variant">
          <div class="stat-decor"></div>
          <div class="stat-icon"><i [class]="stat.icon"></i></div>
          <div class="stat-value" [class.stat-value-text]="stat.isText">{{ stat.value }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="loadingEnquiries">
        <div class="stat-card" *ngFor="let _ of skeletonStatCards">
          <p-skeleton shape="circle" size="38px" styleClass="stat-skeleton-icon"></p-skeleton>
          <p-skeleton width="50%" height="1.4rem" styleClass="stat-skeleton-line"></p-skeleton>
          <p-skeleton width="70%" height="0.9rem"></p-skeleton>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="enquiry-panel">

    <div class="panel-toolbar">
      <div class="filter-dropdown-wrap">
        <select class="native-select filter-select" [(ngModel)]="filterCategoryId" (ngModelChange)="onFilterCategoryChange()">
          <option [ngValue]="null">{{ 'admissionEnquiryPage.allCategories' | translate }}</option>
          <option *ngFor="let category of categories" [ngValue]="category.id">{{ category.label }}</option>
        </select>

        <select class="native-select filter-select" [(ngModel)]="filterClassId" (ngModelChange)="onFilterClassChange()"
          [disabled]="!filterCategoryId || loadingFilterClasses">
          <option [ngValue]="null">{{ loadingFilterClasses ? ('admissionEnquiryPage.loadingClasses' | translate) : ('admissionEnquiryPage.allClasses' | translate) }}</option>
          <option *ngFor="let cls of filterClasses" [ngValue]="cls.id">{{ cls.label }}</option>
        </select>

        <select class="native-select filter-select" [(ngModel)]="filterSectionId" (ngModelChange)="onFilterSectionChange()"
          [disabled]="!filterClassId || loadingFilterSections">
          <option [ngValue]="null">{{ loadingFilterSections ? ('admissionEnquiryPage.loadingSections' | translate) : ('admissionEnquiryPage.allSections' | translate) }}</option>
          <option *ngFor="let section of filterSections" [ngValue]="section.id">{{ section.label }}</option>
        </select>

        <select class="native-select filter-select" [ngModel]="activeFilter" (ngModelChange)="setFilter($event)">
          <option *ngFor="let f of filters" [ngValue]="f.slug">{{ f.label }}</option>
        </select>
      </div>

      <div class="toolbar-actions">
        <div class="search-box">
          <i class="ri-search-line"></i>
          <input type="text" placeholder="{{ 'admissionEnquiryPage.searchPlaceholder' | translate }}" [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange()" />
        </div>
        <button class="btn-export" type="button" [disabled]="isExportingEnquiries" (click)="exportEnquiries()">
          <i class="ri-download-2-line" *ngIf="!isExportingEnquiries"></i>
          <i class="ri-loader-4-line ne-spin" *ngIf="isExportingEnquiries"></i>
          {{ isExportingEnquiries ? ('admissionEnquiryPage.exporting' | translate) : ('admissionEnquiryPage.export' | translate) }}
        </button>
      </div>
    </div>

    <div class="table-wrapper">
      <table class="enquiry-table">
        <thead>
          <tr>
            <th>{{ 'admissionEnquiryPage.colStudent' | translate }}</th>
            <th>{{ 'admissionEnquiryPage.colParentContact' | translate }}</th>
            <th>{{ 'admissionEnquiryPage.colClass' | translate }}</th>
            <th>{{ 'admissionEnquiryPage.colType' | translate }}</th>
            <th>{{ 'admissionEnquiryPage.colEnquiryDate' | translate }}</th>
            <th>{{ 'admissionEnquiryPage.colStatus' | translate }}</th>
            <th>{{ 'admissionEnquiryPage.colAction' | translate }}</th>
          </tr>
        </thead>
        <tbody *ngIf="loadingEnquiries">
          <tr *ngFor="let _ of skeletonRows">
            <td>
              <div class="student-cell">
                <p-skeleton shape="circle" size="36px"></p-skeleton>
                <div class="student-info">
                  <p-skeleton width="120px" height="0.9rem" styleClass="skeleton-line"></p-skeleton>
                  <p-skeleton width="90px" height="0.75rem"></p-skeleton>
                </div>
              </div>
            </td>
            <td>
              <p-skeleton width="100px" height="0.9rem" styleClass="skeleton-line"></p-skeleton>
              <p-skeleton width="80px" height="0.75rem"></p-skeleton>
            </td>
            <td><p-skeleton width="70px" height="0.9rem"></p-skeleton></td>
            <td><p-skeleton width="60px" height="1.4rem"></p-skeleton></td>
            <td><p-skeleton width="80px" height="0.9rem"></p-skeleton></td>
            <td><p-skeleton width="80px" height="1.4rem"></p-skeleton></td>
            <td><p-skeleton width="90px" height="1.6rem"></p-skeleton></td>
          </tr>
        </tbody>
        <tbody *ngIf="!loadingEnquiries">
          <tr *ngFor="let enquiry of pagedEnquiries">
            <td>
              <div class="student-cell">
                <img *ngIf="enquiry.studentImage" [src]="enquiry.studentImage" [alt]="enquiry.studentName" class="student-photo" />
                <div *ngIf="!enquiry.studentImage" class="avatar" [ngClass]="getAvatarClass(enquiry.studentName)">
                  {{ getInitials(enquiry.studentName) }}
                </div>
                <div class="student-info">
                  <div class="student-name">{{ enquiry.studentName }}</div>
                  <div class="student-meta">{{ enquiry.gender }} &middot; DOB {{ enquiry.dob }}</div>
                </div>
              </div>
            </td>
            <td>
              <div class="parent-name">{{ enquiry.parentName }}</div>
              <div class="parent-phone">{{ enquiry.parentPhone }}</div>
            </td>
            <td>{{ enquiry.className }} &middot; {{ enquiry.section }}</td>
            <td>
              <span class="type-badge" [class.type-transfer]="enquiry.type === 'Transfer'">{{ enquiry.type }}</span>
            </td>
            <td>{{ enquiry.enquiryDate }}</td>
            <td>
              <span [class]="getStatusClass(enquiry.statusSlug)">
                <span class="status-dot"></span>{{ enquiry.statusName }}
              </span>
            </td>
            <td>
              <div class="row-actions">
                <button class="icon-btn" title="{{ 'admissionEnquiryPage.view' | translate }}" (click)="openViewEnquiryPanel(enquiry)"><i class="ri-eye-line"></i></button>
                <button class="icon-btn" title="{{ 'admissionEnquiryPage.edit' | translate }}"
                  *ngIf="enquiry.raw?.isAllowedToEdit !== false && permissions.ADMISSION_ENQUIRY_ADD_AND_MANAGE == 'ENABLED'"
                  (click)="openEditEnquiryPanel(enquiry)"><i class="ri-pencil-line"></i></button>
                <button class="icon-btn" title="{{ 'admissionEnquiryPage.admitStudent' | translate }}"
                  *ngIf="!enquiry.raw?.isConverted && permissions.ADMISSION_ENQUIRY_CONVERT == 'ENABLED'"
                  (click)="openAdmitModal(enquiry)"><i class="ri-check-line"></i></button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!loadingEnquiries && pagedEnquiries.length === 0">
            <td colspan="7" class="no-data-cell">
              <div class="empty-state">
                <div class="empty-state-badge">
                  <div class="empty-state-dashed-ring"></div>
                  <i class="ri-user-add-line empty-state-icon"></i>
                  <span class="empty-state-dot empty-state-dot-purple"></span>
                  <span class="empty-state-dot empty-state-dot-green"></span>
                  <span class="empty-state-dot empty-state-dot-orange"></span>
                </div>
                <div class="empty-state-title">{{ 'admissionEnquiryPage.noEnquiriesYet' | translate }}</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="panel-footer" *ngIf="recordsFiltered > 0">
      <div class="results-summary">
        {{ 'admissionEnquiryPage.showing' | translate }} <strong>{{ resultRangeStart }}&ndash;{{ resultRangeEnd }}</strong> {{ 'admissionEnquiryPage.of' | translate }}
        <strong>{{ recordsFiltered }}</strong> {{ 'admissionEnquiryPage.enquiries' | translate }}
      </div>
      <p-paginator styleClass="ne-list-paginator" [first]="paginatorFirst" [rows]="pageSize"
        [totalRecords]="recordsFiltered" [rowsPerPageOptions]="[10, 20, 50]"
        (onPageChange)="onPaginatorPageChange($event)"></p-paginator>
    </div>

  </div>

      </section>
    </div>
  </div>
</div>

<p-dialog *ngIf="!isEditMode" [(visible)]="showNewEnquiryModal" [modal]="true" [closable]="false" [draggable]="false"
  [style]="{ width: '900px', maxWidth: '95vw' }" styleClass="new-enquiry-dialog" (onShow)="onNewEnquiryModalShown()">
  <ng-container *ngTemplateOutlet="enquiryFormContent"></ng-container>
</p-dialog>

<div class="ne-panel-overlay" *ngIf="isEditMode && showNewEnquiryModal" (click)="closeNewEnquiryModal()"></div>
<div class="ne-edit-panel" *ngIf="isEditMode && showNewEnquiryModal">
  <ng-container *ngTemplateOutlet="enquiryFormContent"></ng-container>
</div>

<ng-template #enquiryFormContent>
  <div class="ne-modal-head">
    <h3 class="ne-modal-title">{{ showEnquirySuccess ? ('admissionEnquiryPage.enquirySubmitted' | translate) : (isEditMode ? ('admissionEnquiryPage.editAdmissionEnquiry' | translate) : ('admissionEnquiryPage.newAdmissionEnquiry' | translate)) }}</h3>
    <button class="ne-close-btn" (click)="closeNewEnquiryModal()"><i class="ri-close-line"></i></button>
  </div>

  <div class="ne-success-body" *ngIf="showEnquirySuccess">
    <ng-lottie [options]="successAnimationOptions" class="ne-success-animation"></ng-lottie>
    <h4 class="ne-success-title">{{ enquirySuccessMessage }}</h4>
    <div class="ne-success-reference" *ngIf="enquirySuccessReferenceNumber">
      <span class="ne-success-reference-label">{{ 'admissionEnquiryPage.referenceNumber' | translate }}</span>
      <span class="ne-success-reference-value">{{ enquirySuccessReferenceNumber }}</span>
    </div>
    <button class="ne-btn ne-btn-primary" type="button" (click)="closeNewEnquiryModal()">{{ 'admissionEnquiryPage.done' | translate }}</button>
  </div>

  <div class="ne-modal-body" *ngIf="!showEnquirySuccess">

    <!-- Step 1: Student Details -->
    <div class="ne-section-card">
      <h4 class="ne-section-title"><span class="ne-step-badge">1</span> {{ 'admissionEnquiryPage.studentDetails' | translate }}</h4>

      <div class="ne-photo-row">
        <div class="ne-photo-box">
          <img *ngIf="studentImagePreview" [src]="studentImagePreview" class="ne-photo-img" alt="" />
          <i *ngIf="!studentImagePreview" class="ri-user-line ne-photo-placeholder"></i>
          <button class="ne-photo-camera-badge" type="button" (click)="studentImageInput.click()"><i class="ri-camera-line"></i></button>
        </div>
        <input type="file" #studentImageInput accept="image/*" class="ne-hidden-file-input" (change)="onStudentImageSelected($event)" />
        <div class="ne-photo-info">
          <div class="ne-photo-label">{{ 'admissionEnquiryPage.studentPhoto' | translate }}</div>
          <div class="ne-photo-hint">{{ 'admissionEnquiryPage.photoHint' | translate }}</div>
          <div class="ne-photo-actions">
            <button class="ne-upload-photo-btn" type="button" (click)="studentImageInput.click()">
              <i class="ri-upload-2-line"></i> {{ studentImagePreview ? ('admissionEnquiryPage.changePhoto' | translate) : ('admissionEnquiryPage.uploadPhoto' | translate) }}
            </button>
            <button class="ne-remove-file-btn" type="button" *ngIf="studentImagePreview" (click)="removeStudentImage()">
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
        </div>
        <div class="ne-field ne-status-field" *ngIf="isEditMode">
          <label>{{ 'admissionEnquiryPage.status' | translate }}</label>
          <select class="ne-input ne-select" [(ngModel)]="newEnquiryForm.statusId" [disabled]="loadingEnquiryStatuses">
            <option [ngValue]="null" disabled>{{ loadingEnquiryStatuses ? ('admissionEnquiryPage.loadingStatuses' | translate) : ('admissionEnquiryPage.selectStatus' | translate) }}</option>
            <option *ngFor="let status of enquiryStatuses" [ngValue]="status.id">{{ status.label }}</option>
          </select>
        </div>
      </div>

      <div class="ne-grid ne-grid-3">
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.firstName' | translate }} <span class="ne-required">*</span></label>
          <input type="text" class="ne-input" [class.ne-input-error]="fieldErrors.firstName" placeholder="{{ 'admissionEnquiryPage.enterFirstName' | translate }}"
            [(ngModel)]="newEnquiryForm.firstName" />
          <span class="ne-error-text" *ngIf="fieldErrors.firstName">{{ fieldErrors.firstName }}</span>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.lastName' | translate }}</label>
          <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterLastName' | translate }}" [(ngModel)]="newEnquiryForm.lastName" />
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.dateOfBirth' | translate }} <span class="ne-required">*</span></label>
          <p-calendar [(ngModel)]="newEnquiryForm.dob" [ngModelOptions]="{standalone: true}" inputId="ne-dob"
            [styleClass]="'ne-calendar' + (fieldErrors.dob ? ' ne-calendar-error' : '')" dateFormat="dd/mm/yy"
            [maxDate]="today" [showIcon]="true" appendTo="body" placeholder="{{ 'admissionEnquiryPage.ddmmyyyy' | translate }}"></p-calendar>
          <span class="ne-error-text" *ngIf="fieldErrors.dob">{{ fieldErrors.dob }}</span>
        </div>
      </div>

      <div class="ne-grid ne-grid-3">
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.gender' | translate }} <span class="ne-required">*</span></label>
          <div class="ne-pill-toggle">
            <button type="button" class="ne-pill" [class.active]="newEnquiryForm.gender === 'Male'"
              (click)="setEnquiryGender('Male')">
              <span class="ne-pill-dot"></span> {{ 'admissionEnquiryPage.male' | translate }}
            </button>
            <button type="button" class="ne-pill" [class.active]="newEnquiryForm.gender === 'Female'"
              (click)="setEnquiryGender('Female')">
              <span class="ne-pill-dot"></span> {{ 'admissionEnquiryPage.female' | translate }}
            </button>
          </div>
          <span class="ne-error-text" *ngIf="fieldErrors.gender">{{ fieldErrors.gender }}</span>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.academicYear' | translate }} <span class="ne-required">*</span></label>
          <select class="ne-input ne-select" [class.ne-input-error]="fieldErrors.academicYearId" [(ngModel)]="newEnquiryForm.academicYearId"
            [disabled]="loadingAcademicYears">
            <option [ngValue]="null" disabled>{{ loadingAcademicYears ? ('admissionEnquiryPage.loadingAcademicYears' | translate) : ('admissionEnquiryPage.selectAcademicYear' | translate) }}</option>
            <option *ngFor="let year of academicYears" [value]="year.id">
              {{ year.label }}<ng-container *ngIf="year.isCurrent"> {{ 'admissionEnquiryPage.current' | translate }}</ng-container>
            </option>
          </select>
          <span class="ne-error-text" *ngIf="fieldErrors.academicYearId">{{ fieldErrors.academicYearId }}</span>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.category' | translate }} <span class="ne-required">*</span></label>
          <select class="ne-input ne-select" [class.ne-input-error]="fieldErrors.categoryId" [(ngModel)]="newEnquiryForm.categoryId"
            (ngModelChange)="onEnquiryCategoryChange()" [disabled]="loadingCategories">
            <option [ngValue]="null" disabled>{{ loadingCategories ? ('admissionEnquiryPage.loadingCategories' | translate) : ('admissionEnquiryPage.selectCategory' | translate) }}</option>
            <option *ngFor="let category of categories" [value]="category.id">{{ category.label }}</option>
          </select>
          <span class="ne-error-text" *ngIf="fieldErrors.categoryId">{{ fieldErrors.categoryId }}</span>
        </div>
      </div>

      <div class="ne-grid ne-grid-2">
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.classStandard' | translate }} <span class="ne-required">*</span></label>
          <select class="ne-input ne-select" [class.ne-input-error]="fieldErrors.classId" [(ngModel)]="newEnquiryForm.classId"
            (ngModelChange)="onEnquiryClassChange()" [disabled]="!newEnquiryForm.categoryId || loadingClasses">
            <option [ngValue]="null" disabled>{{ loadingClasses ? ('admissionEnquiryPage.loadingClasses' | translate) : ('admissionEnquiryPage.selectClass' | translate) }}</option>
            <option *ngFor="let cls of filteredClasses" [value]="cls.id">{{ cls.label }}</option>
          </select>
          <span class="ne-error-text" *ngIf="fieldErrors.classId">{{ fieldErrors.classId }}</span>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.section' | translate }}</label>
          <select class="ne-input ne-select" [(ngModel)]="newEnquiryForm.sectionId"
            [disabled]="!newEnquiryForm.classId || loadingSections">
            <option [ngValue]="null">{{ loadingSections ? ('admissionEnquiryPage.loadingSections' | translate) : ('admissionEnquiryPage.selectSection' | translate) }}</option>
            <option *ngFor="let section of filteredSections" [value]="section.id">{{ section.label }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Step 2: Admission Type -->
    <div class="ne-section-card">
      <h4 class="ne-section-title"><span class="ne-step-badge">2</span> {{ 'admissionEnquiryPage.admissionType' | translate }}</h4>

      <div class="ne-field">
        <label>{{ 'admissionEnquiryPage.admissionType' | translate }} <span class="ne-required">*</span></label>
        <div class="ne-pill-toggle ne-pill-toggle-wide">
          <button type="button" class="ne-pill" [class.active]="newEnquiryForm.admissionType === 'Fresh'"
            (click)="setAdmissionType('Fresh')">
            <span class="ne-pill-dot"></span> {{ 'admissionEnquiryPage.fresh' | translate }}
          </button>
          <button type="button" class="ne-pill" [class.active]="newEnquiryForm.admissionType === 'Transfer'"
            (click)="setAdmissionType('Transfer')">
            <span class="ne-pill-dot"></span> {{ 'admissionEnquiryPage.transfer' | translate }}
          </button>
        </div>
      </div>

      <div class="ne-transfer-panel" *ngIf="newEnquiryForm.admissionType === 'Transfer'">
        <div class="ne-transfer-heading"><i class="ri-arrow-right-s-line"></i> {{ 'admissionEnquiryPage.transferPreviousSchoolDetails' | translate }}</div>
        <div class="ne-transfer-note">{{ 'admissionEnquiryPage.transferRequiresPreviousSchool' | translate }}</div>

        <div class="ne-grid ne-grid-2">
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.previousSchoolName' | translate }}</label>
            <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterPreviousSchoolName' | translate }}"
              [(ngModel)]="newEnquiryForm.previousSchoolName" />
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.board' | translate }}</label>
            <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterBoard' | translate }}" [(ngModel)]="newEnquiryForm.board" />
          </div>
        </div>

        <div class="ne-grid ne-grid-3">
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.previousClassStudied' | translate }}</label>
            <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterPreviousClass' | translate }}" [(ngModel)]="newEnquiryForm.previousClassStudied" />
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.previousClassResult' | translate }}</label>
            <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterResult' | translate }}" [(ngModel)]="newEnquiryForm.previousClassResult" />
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.reasonForTransfer' | translate }}</label>
            <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterReason' | translate }}" [(ngModel)]="newEnquiryForm.reasonForTransfer" />
          </div>
        </div>

        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.previousSchoolAddress' | translate }}</label>
          <textarea class="ne-input ne-textarea" rows="2" placeholder="{{ 'admissionEnquiryPage.enterAddress' | translate }}"
            [(ngModel)]="newEnquiryForm.previousSchoolAddress"></textarea>
        </div>

        <div class="ne-grid ne-grid-3">
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.tcNumber' | translate }}</label>
            <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterTcNumber' | translate }}" [(ngModel)]="newEnquiryForm.tcNumber" />
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.tcDate' | translate }}</label>
            <p-calendar [(ngModel)]="newEnquiryForm.tcDate" [ngModelOptions]="{standalone: true}" inputId="ne-tc-date"
              styleClass="ne-calendar" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
              placeholder="{{ 'admissionEnquiryPage.ddmmyyyy' | translate }}"></p-calendar>
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.tcDocument' | translate }}</label>
            <div class="ne-file-upload-row">
              <button class="ne-upload-btn" type="button"
                (click)="tcDocumentFile ? previewTcDocument() : (originalTcDocumentUrl ? openOriginalTcDocument() : tcDocumentInput.click())"
                [title]="tcDocumentFile ? tcDocumentFile.name : (originalTcDocumentName || ('admissionEnquiryPage.uploadTc' | translate))">
                <i [class]="(tcDocumentFile || originalTcDocumentUrl) ? 'ri-eye-line' : 'ri-upload-2-line'"></i>
                <span class="ne-upload-btn-text">{{ tcDocumentFile ? tcDocumentFile.name : (originalTcDocumentName || ('admissionEnquiryPage.uploadTc' | translate)) }}</span>
              </button>
              <button class="ne-remove-file-btn" type="button" *ngIf="tcDocumentFile || originalTcDocumentUrl"
                (click)="removeTcDocument()">
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
            <input type="file" #tcDocumentInput accept=".pdf,image/*" class="ne-hidden-file-input"
              (change)="onTcDocumentSelected($event)" />
          </div>
        </div>
      </div>
    </div>

    <!-- Step 3: Parent / Guardian Details -->
    <div class="ne-section-card">
      <h4 class="ne-section-title"><span class="ne-step-badge">3</span> {{ 'admissionEnquiryPage.parentGuardianDetails' | translate }}</h4>

      <div class="ne-parent-block">
        <div class="ne-parent-heading ne-parent-heading-father">{{ 'admissionEnquiryPage.father' | translate }}</div>
        <div class="ne-grid ne-grid-3">
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.fathersName' | translate }} <span class="ne-required">*</span></label>
            <input type="text" class="ne-input" [class.ne-input-error]="fieldErrors.fatherName" placeholder="{{ 'admissionEnquiryPage.enterFathersName' | translate }}"
              [(ngModel)]="newEnquiryForm.fatherName" />
            <span class="ne-error-text" *ngIf="fieldErrors.fatherName">{{ fieldErrors.fatherName }}</span>
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.mobileNumber' | translate }} <span class="ne-required">*</span></label>
            <input type="text" id="ne-father-mobile" class="ne-input ne-phone-input" [class.ne-input-error]="fieldErrors.fatherMobile"
              placeholder="{{ 'admissionEnquiryPage.enterMobileNumber' | translate }}" [(ngModel)]="newEnquiryForm.fatherMobile"
              inputmode="numeric" (keydown)="handleMobileKeyDown($event)" />
            <span class="ne-error-text" *ngIf="fieldErrors.fatherMobile">{{ fieldErrors.fatherMobile }}</span>
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.email' | translate }} <span class="ne-required">*</span></label>
            <input type="email" class="ne-input" [class.ne-input-error]="fieldErrors.fatherEmail" placeholder="{{ 'admissionEnquiryPage.enterEmailAddress' | translate }}"
              [(ngModel)]="newEnquiryForm.fatherEmail" />
            <span class="ne-error-text" *ngIf="fieldErrors.fatherEmail">{{ fieldErrors.fatherEmail }}</span>
          </div>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.address' | translate }} <span class="ne-required">*</span></label>
          <textarea class="ne-input ne-textarea" rows="2" [class.ne-input-error]="fieldErrors.fatherAddress" placeholder="{{ 'admissionEnquiryPage.enterAddress' | translate }}"
            [(ngModel)]="newEnquiryForm.fatherAddress"></textarea>
          <span class="ne-error-text" *ngIf="fieldErrors.fatherAddress">{{ fieldErrors.fatherAddress }}</span>
        </div>
      </div>

      <div class="ne-parent-block">
        <div class="ne-parent-heading ne-parent-heading-mother">{{ 'admissionEnquiryPage.mother' | translate }}</div>
        <div class="ne-grid ne-grid-3">
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.mothersName' | translate }}</label>
            <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterMothersName' | translate }}" [(ngModel)]="newEnquiryForm.motherName" />
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.mobileNumber' | translate }}</label>
            <input type="text" id="ne-mother-mobile" class="ne-input ne-phone-input" [class.ne-input-error]="fieldErrors.motherMobile"
              placeholder="{{ 'admissionEnquiryPage.enterMobileNumber' | translate }}"
              [(ngModel)]="newEnquiryForm.motherMobile" inputmode="numeric" (keydown)="handleMobileKeyDown($event)" />
            <span class="ne-error-text" *ngIf="fieldErrors.motherMobile">{{ fieldErrors.motherMobile }}</span>
          </div>
          <div class="ne-field">
            <label>{{ 'admissionEnquiryPage.email' | translate }}</label>
            <input type="email" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterEmailAddress' | translate }}" [(ngModel)]="newEnquiryForm.motherEmail" />
          </div>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.address' | translate }}</label>
          <textarea class="ne-input ne-textarea" rows="2" placeholder="{{ 'admissionEnquiryPage.enterAddress' | translate }}" [(ngModel)]="newEnquiryForm.motherAddress"></textarea>
        </div>
      </div>
    </div>

  </div>

  <div class="ne-modal-foot" *ngIf="!showEnquirySuccess">
    <div class="ne-foot-actions">
      <button class="ne-btn ne-btn-secondary" type="button" (click)="resetNewEnquiryForm()" [disabled]="isSubmittingEnquiry" *ngIf="!isEditMode">{{ 'admissionEnquiryPage.reset' | translate }}</button>
      <button class="ne-btn ne-btn-secondary" type="button" (click)="closeNewEnquiryModal()" [disabled]="isSubmittingEnquiry" *ngIf="isEditMode">{{ 'admissionEnquiryPage.cancel' | translate }}</button>
      <button class="ne-btn ne-btn-primary" type="button" (click)="submitNewEnquiry()" [disabled]="isSubmittingEnquiry">
        <i class="ri-send-plane-line" *ngIf="!isSubmittingEnquiry"></i>
        {{ isSubmittingEnquiry ? ('admissionEnquiryPage.submitting' | translate) : (isEditMode ? ('admissionEnquiryPage.saveChanges' | translate) : ('admissionEnquiryPage.submitEnquiry' | translate)) }}
      </button>
    </div>
  </div>
</ng-template>

<div class="ne-panel-overlay" *ngIf="showViewEnquiryPanel" (click)="closeViewEnquiryPanel()"></div>
<div class="ne-view-panel" *ngIf="showViewEnquiryPanel && viewingEnquiry">

  <div class="ne-view-head">
    <h3 class="ne-modal-title">{{ 'admissionEnquiryPage.enquiryDetails' | translate }}</h3>
    <div class="ne-view-head-actions">
      <button class="ne-view-action-btn" type="button" (click)="openHistoryPanel()">
        <i class="ri-history-line"></i> {{ 'admissionEnquiryPage.history' | translate }}
      </button>
      <button class="ne-view-action-btn" type="button" (click)="printEnquiryDetails()">
        <i class="ri-printer-line"></i> {{ 'admissionEnquiryPage.print' | translate }}
      </button>
      <button class="ne-close-btn" (click)="closeViewEnquiryPanel()"><i class="ri-close-line"></i></button>
    </div>
  </div>

  <div class="ne-view-body" id="ne-view-print-area">

    <div class="ne-view-hero">
      <img *ngIf="viewingEnquiry.studentImage" [src]="viewingEnquiry.studentImage" class="ne-view-hero-photo" alt="" />
      <div *ngIf="!viewingEnquiry.studentImage" class="avatar ne-view-hero-avatar" [ngClass]="getAvatarClass(viewingEnquiry.studentName)">
        {{ getInitials(viewingEnquiry.studentName) }}
      </div>
      <div class="ne-view-hero-name">{{ viewingEnquiry.studentName }}</div>
      <span [class]="getStatusClass(viewingEnquiry.statusSlug)" class="ne-view-hero-status">
        <span class="status-dot"></span>{{ viewingEnquiry.statusName }}
      </span>
    </div>

    <div class="ne-view-card">
      <div class="ne-view-card-head">
        <span class="ne-view-icon-badge"><i class="ri-user-line"></i></span>
        <h4 class="ne-view-section-title">{{ 'admissionEnquiryPage.studentDetails' | translate }}</h4>
      </div>
      <div class="ne-view-field ne-view-field-full">
        <span class="ne-view-label">{{ 'admissionEnquiryPage.preRegistrationNo' | translate }}</span>
        <span class="ne-view-code-pill">{{ viewingEnquiry.raw?.preRegistrationNumber || '—' }}</span>
      </div>
      <div class="ne-view-grid">
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.category' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.categoryName || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.classSection' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.className || '—' }}{{ viewingEnquiry.section ? ' · ' + viewingEnquiry.section : '' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.admissionType' | translate }}</span>
          <span class="type-badge" [class.type-transfer]="viewingEnquiry.type === 'Transfer'">{{ viewingEnquiry.type }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.colEnquiryDate' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.enquiryDate || '—' }}</span>
        </div>
      </div>
    </div>

    <div class="ne-view-card" *ngIf="viewingEnquiry.type === 'Transfer'">
      <div class="ne-view-card-head">
        <span class="ne-view-icon-badge"><i class="ri-arrow-right-line"></i></span>
        <h4 class="ne-view-section-title">{{ 'admissionEnquiryPage.transferPreviousSchoolDetails' | translate }}</h4>
      </div>
      <div class="ne-view-grid">
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.previousSchoolName' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.previousSchoolName || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.board' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.previousSchoolBoard || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.previousClassStudied' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.previousClassStudied || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.previousClassResult' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.previousClassResult || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.reasonForTransfer' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.reasonForTransfer || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.tcNumber' | translate }}</span>
          <span class="ne-view-code-pill">{{ viewingEnquiry.raw?.tcNumber || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.tcDocument' | translate }}</span>
          <button class="ne-view-doc-link" type="button" *ngIf="viewingEnquiry.raw?.tcDocumentUrl"
            (click)="previewDocumentUrl(viewingEnquiry.raw?.tcDocumentUrl, viewingEnquiry.raw?.tcDocumentType, tcDocumentLabel)">
            <i class="ri-eye-line"></i> {{ 'admissionEnquiryPage.viewDocument' | translate }}
          </button>
          <span class="ne-view-value" *ngIf="!viewingEnquiry.raw?.tcDocumentUrl">—</span>
        </div>
        <div class="ne-view-field ne-view-field-full">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.previousSchoolAddress' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.previousSchoolAddress || '—' }}</span>
        </div>
      </div>
    </div>

    <div class="ne-view-card">
      <div class="ne-view-card-head">
        <span class="ne-view-icon-badge ne-view-icon-badge-father"><i class="ri-men-line"></i></span>
        <h4 class="ne-view-section-title">{{ 'admissionEnquiryPage.father' | translate }}</h4>
      </div>
      <div class="ne-view-grid">
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.name' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.fatherName || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.mobile' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.parentPhone || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.email' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.fatherEmailId || '—' }}</span>
        </div>
        <div class="ne-view-field ne-view-field-full">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.address' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.fatherAddress || '—' }}</span>
        </div>
      </div>
    </div>

    <div class="ne-view-card" *ngIf="viewingEnquiry.raw?.motherName">
      <div class="ne-view-card-head">
        <span class="ne-view-icon-badge ne-view-icon-badge-mother"><i class="ri-women-line"></i></span>
        <h4 class="ne-view-section-title">{{ 'admissionEnquiryPage.mother' | translate }}</h4>
      </div>
      <div class="ne-view-grid">
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.name' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.motherName || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.mobile' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.motherMobileNumber || '—' }}</span>
        </div>
        <div class="ne-view-field">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.email' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.motherEmailId || '—' }}</span>
        </div>
        <div class="ne-view-field ne-view-field-full">
          <span class="ne-view-label">{{ 'admissionEnquiryPage.address' | translate }}</span>
          <span class="ne-view-value">{{ viewingEnquiry.raw?.motherAddress || '—' }}</span>
        </div>
      </div>
    </div>

  </div>

  <div class="ne-view-foot" *ngIf="!viewingEnquiry.raw?.isConverted">
    <button class="ne-btn ne-btn-secondary" type="button"
      *ngIf="viewingEnquiry.raw?.isAllowedToEdit !== false && permissions.ADMISSION_ENQUIRY_ADD_AND_MANAGE == 'ENABLED'"
      (click)="editFromViewPanel()">
      <i class="ri-pencil-line"></i> {{ 'admissionEnquiryPage.edit' | translate }}
    </button>
    <button class="ne-btn ne-btn-primary" type="button" (click)="openAdmitModal(viewingEnquiry)"
      *ngIf="permissions.ADMISSION_ENQUIRY_CONVERT == 'ENABLED'">
      <i class="ri-check-line"></i> {{ 'admissionEnquiryPage.admitStudent' | translate }}
    </button>
  </div>
</div>

<div class="ne-panel-overlay" *ngIf="showHistoryPanel" (click)="closeHistoryPanel()"></div>
<div class="ne-history-panel" *ngIf="showHistoryPanel && viewingEnquiry">

  <div class="ne-history-head">
    <button class="ne-history-back-btn" type="button" (click)="backToViewFromHistory()">
      <i class="ri-arrow-left-s-line"></i>
    </button>
    <div class="ne-history-head-text">
      <h3 class="ne-modal-title">{{ 'admissionEnquiryPage.history' | translate }}</h3>
      <div class="ne-history-subtitle">{{ viewingEnquiry.studentName }} &middot; {{ viewingEnquiry.raw?.preRegistrationNumber }}</div>
    </div>
    <button class="ne-close-btn" (click)="closeHistoryPanel()"><i class="ri-close-line"></i></button>
  </div>

  <div class="ne-history-body">
    <div class="ne-history-loading" *ngIf="loadingHistory">
      <p-skeleton width="100%" height="80px" styleClass="skeleton-line"></p-skeleton>
      <p-skeleton width="100%" height="80px" styleClass="skeleton-line"></p-skeleton>
      <p-skeleton width="100%" height="80px"></p-skeleton>
    </div>

    <div class="ne-history-timeline" *ngIf="!loadingHistory">
      <div class="ne-history-item" *ngFor="let entry of historyLog; let i = index; let last = last">
        <div class="ne-history-marker">
          <span [class]="getActivityDotClass(i === 0)"></span>
          <span class="ne-history-line" *ngIf="!last"></span>
        </div>
        <div class="ne-history-content">
          <div class="ne-history-row-top">
            <div class="ne-history-title">{{ getActivityTitle(entry) }}</div>
            <div class="ne-history-time">{{ entry.date }} &middot; {{ entry.time }}</div>
          </div>

          <div class="ne-history-change-row" *ngIf="getStatusChange(entry) as statusChange">
            <span class="ne-history-field-name">{{ statusChange.fieldName }}</span>
            <div class="ne-history-status-change">
              <span class="ne-history-old-value">{{ formatHistoryValue(statusChange.oldValue) }}</span>
              <i class="ri-arrow-right-line"></i>
              <span class="ne-history-new-value">{{ formatHistoryValue(statusChange.newValue) }}</span>
            </div>
          </div>

          <ng-container *ngFor="let change of getNonStatusChanges(entry)">
            <div class="ne-history-change-row" *ngIf="!isDocumentChange(change)">
              <span class="ne-history-field-name">{{ change.fieldName }}</span>
              <div class="ne-history-status-change">
                <span class="ne-history-old-value">{{ formatHistoryValue(change.oldValue) }}</span>
                <i class="ri-arrow-right-line"></i>
                <span class="ne-history-new-value">{{ formatHistoryValue(change.newValue) }}</span>
              </div>
            </div>
            <div class="ne-history-change-row" *ngIf="isDocumentChange(change)">
              <span class="ne-history-field-name">{{ change.fieldName }}</span>
              <div class="ne-history-status-change">
                <button type="button" class="ne-history-doc-pill ne-history-old-value" *ngIf="hasDocumentValue(change.oldValue)"
                  (click)="previewDocumentUrl(change.oldValue, change.oldValueDocumentType, change.fieldName + ' (previous)')">
                  {{ 'admissionEnquiryPage.viewPrevious' | translate }}
                </button>
                <span class="ne-history-old-value" *ngIf="!hasDocumentValue(change.oldValue)">{{ 'admissionEnquiryPage.documentAdded' | translate }}</span>

                <i class="ri-arrow-right-line"></i>

                <button type="button" class="ne-history-doc-pill ne-history-new-value" *ngIf="hasDocumentValue(change.newValue)"
                  (click)="previewDocumentUrl(change.newValue, change.newValueDocumentType, change.fieldName)">
                  {{ 'admissionEnquiryPage.viewCurrent' | translate }}
                </button>
                <span class="ne-history-new-value" *ngIf="!hasDocumentValue(change.newValue)">{{ 'admissionEnquiryPage.documentRemoved' | translate }}</span>
              </div>
            </div>
          </ng-container>

          <div class="ne-history-remarks" *ngIf="entry.action === 'CREATED' || entry.action === 'CONVERTED'">
            {{ entry.remarks }}
          </div>

          <div class="ne-history-by">{{ 'admissionEnquiryPage.by' | translate }} <strong>{{ entry.performedBy?.name }}</strong></div>
        </div>
      </div>

      <div class="ne-history-empty" *ngIf="historyLog.length === 0">{{ 'admissionEnquiryPage.noActivityRecordedYet' | translate }}</div>
    </div>
  </div>
</div>

<div class="ne-doc-preview-overlay" *ngIf="isDocumentPreviewOpen" (click)="closeDocumentPreview()">
  <button type="button" class="ne-doc-preview-close-btn" (click)="closeDocumentPreview()">
    <i class="ri-close-line"></i>
  </button>
  <div class="ne-doc-preview-content" [class.ne-doc-preview-content-doc]="documentPreviewType === 'document'"
    (click)="$event.stopPropagation()">
    <img *ngIf="documentPreviewType === 'image'" [src]="documentPreviewUrl" [alt]="documentPreviewLabel"
      class="ne-doc-preview-image" />
    <iframe *ngIf="documentPreviewType === 'document'" [src]="documentPreviewSafeUrl" class="ne-doc-preview-iframe"
      title="{{ 'admissionEnquiryPage.documentPreview' | translate }}"></iframe>
    <div class="ne-doc-preview-unsupported" *ngIf="documentPreviewType === 'unsupported'">
      <i class="ri-file-3-line ne-doc-preview-unsupported-icon"></i>
      <p class="ne-doc-preview-unsupported-text">{{ 'admissionEnquiryPage.fileTypeNotPreviewable' | translate }}</p>
      <a [href]="documentPreviewUrl" target="_blank" rel="noopener" class="ne-doc-preview-open-btn">
        <i class="ri-external-link-line"></i> {{ 'admissionEnquiryPage.openDocument' | translate }}
      </a>
    </div>
    <div class="ne-doc-preview-label">{{ documentPreviewLabel }}</div>
  </div>
</div>

<p-dialog [(visible)]="showAdmitModal" [modal]="true" [closable]="false" [draggable]="false"
  [style]="{ width: '640px', maxWidth: '95vw' }" styleClass="new-enquiry-dialog">
  <div class="ne-modal-head">
    <h3 class="ne-modal-title">{{ 'admissionEnquiryPage.admitStudent' | translate }}</h3>
    <button class="ne-close-btn" (click)="closeAdmitModal()"><i class="ri-close-line"></i></button>
  </div>

  <div class="ne-modal-body" *ngIf="admittingEnquiry && !showAdmitConfirm">
    <div class="ne-admit-student-strip">
      <img *ngIf="admittingEnquiry.studentImage" [src]="admittingEnquiry.studentImage" class="ne-admit-student-photo" alt="" />
      <div *ngIf="!admittingEnquiry.studentImage" class="avatar ne-admit-student-photo" [ngClass]="getAvatarClass(admittingEnquiry.studentName)">
        {{ getInitials(admittingEnquiry.studentName) }}
      </div>
      <div class="ne-admit-student-info">
        <div class="ne-admit-student-name">{{ admittingEnquiry.studentName }}</div>
        <div class="ne-admit-student-meta">
          {{ admittingEnquiry.className }}{{ admittingEnquiry.section ? ' · ' + admittingEnquiry.section : '' }}
          &middot; {{ admittingEnquiry.type }}
          <ng-container *ngIf="admittingEnquiry.raw?.preRegistrationNumber"> &middot; {{ admittingEnquiry.raw?.preRegistrationNumber }}</ng-container>
        </div>
      </div>
    </div>

    <div class="ne-section-card">
      <h4 class="ne-section-title"><span class="ne-step-badge">1</span> {{ 'admissionEnquiryPage.admissionDetails' | translate }}</h4>
      <div class="ne-grid ne-grid-2">
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.registrationId' | translate }} <span class="ne-required">*</span>
            <span class="ne-last-reg-hint" *ngIf="lastRegistrationId">({{ 'admissionEnquiryPage.lastReg' | translate }} <b>{{ lastRegistrationId }}</b>)</span>
          </label>
          <input type="text" class="ne-input" placeholder="{{ 'admissionEnquiryPage.enterRegistrationId' | translate }}"
            [class.ne-input-error]="admitFieldErrors.registrationId"
            [(ngModel)]="admitForm.registrationId" [ngModelOptions]="{standalone: true}" />
          <span class="ne-error-text" *ngIf="admitFieldErrors.registrationId">{{ admitFieldErrors.registrationId }}</span>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.dateOfAdmission' | translate }} <span class="ne-required">*</span></label>
          <p-calendar [(ngModel)]="admitForm.dateOfAdmission" [ngModelOptions]="{standalone: true}" inputId="ne-admit-date"
            [styleClass]="'ne-calendar' + (admitFieldErrors.dateOfAdmission ? ' ne-calendar-error' : '')" dateFormat="dd/mm/yy"
            [maxDate]="today" [showIcon]="true" appendTo="body" placeholder="{{ 'admissionEnquiryPage.ddmmyyyy' | translate }}"></p-calendar>
          <span class="ne-error-text" *ngIf="admitFieldErrors.dateOfAdmission">{{ admitFieldErrors.dateOfAdmission }}</span>
        </div>
        <div class="ne-field ne-field-full">
          <label>{{ 'admissionEnquiryPage.admissionStream' | translate }} <span class="ne-required">*</span></label>
          <select class="ne-input" [(ngModel)]="admitForm.admissionStream" [ngModelOptions]="{standalone: true}"
            [disabled]="loadingAdmissionStreams">
            <option value="general">{{ loadingAdmissionStreams ? ('admissionEnquiryPage.loading' | translate) : ('admissionEnquiryPage.generalDefault' | translate) }}</option>
            <option *ngFor="let stream of admissionStreamOptions" [value]="stream.id">{{ stream.label }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="ne-section-card">
      <h4 class="ne-section-title"><span class="ne-step-badge">2</span> {{ 'admissionEnquiryPage.classDetails' | translate }}</h4>
      <div class="ne-grid ne-grid-3">
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.category' | translate }} <span class="ne-required">*</span></label>
          <select class="ne-input" [class.ne-input-error]="admitFieldErrors.categoryId"
            [(ngModel)]="admitForm.categoryId" [ngModelOptions]="{standalone: true}"
            [disabled]="loadingAdmitCategories" (ngModelChange)="onAdmitCategoryChange()">
            <option [ngValue]="null">{{ loadingAdmitCategories ? ('admissionEnquiryPage.loading' | translate) : ('admissionEnquiryPage.selectCategory' | translate) }}</option>
            <option *ngFor="let category of admitCategories" [ngValue]="category.id">{{ category.label }}</option>
          </select>
          <span class="ne-error-text" *ngIf="admitFieldErrors.categoryId">{{ admitFieldErrors.categoryId }}</span>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.class' | translate }} <span class="ne-required">*</span></label>
          <select class="ne-input" [class.ne-input-error]="admitFieldErrors.classId"
            [(ngModel)]="admitForm.classId" [ngModelOptions]="{standalone: true}"
            [disabled]="!admitForm.categoryId || loadingAdmitClasses" (ngModelChange)="onAdmitClassChange()">
            <option [ngValue]="null">{{ loadingAdmitClasses ? ('admissionEnquiryPage.loading' | translate) : ('admissionEnquiryPage.selectClass' | translate) }}</option>
            <option *ngFor="let cls of admitClasses" [ngValue]="cls.id">{{ cls.label }}</option>
          </select>
          <span class="ne-error-text" *ngIf="admitFieldErrors.classId">{{ admitFieldErrors.classId }}</span>
        </div>
        <div class="ne-field">
          <label>{{ 'admissionEnquiryPage.section' | translate }} <span class="ne-required">*</span></label>
          <select class="ne-input" [class.ne-input-error]="admitFieldErrors.sectionId"
            [(ngModel)]="admitForm.sectionId" [ngModelOptions]="{standalone: true}"
            [disabled]="!admitForm.classId || loadingAdmitSections">
            <option [ngValue]="null">{{ loadingAdmitSections ? ('admissionEnquiryPage.loading' | translate) : ('admissionEnquiryPage.selectSection' | translate) }}</option>
            <option *ngFor="let section of admitSections" [ngValue]="section.id">{{ section.label }}</option>
          </select>
          <span class="ne-error-text" *ngIf="admitFieldErrors.sectionId">{{ admitFieldErrors.sectionId }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="ne-modal-foot" *ngIf="admittingEnquiry && !showAdmitConfirm">
    <span class="ne-foot-note">{{ 'admissionEnquiryPage.requiredFields' | translate }}</span>
    <div class="ne-foot-actions">
      <button class="ne-btn ne-btn-secondary" type="button" (click)="closeAdmitModal()" [disabled]="isSubmittingAdmit">{{ 'admissionEnquiryPage.cancel' | translate }}</button>
      <button class="ne-btn ne-btn-primary" type="button" (click)="submitAdmitStudent()" [disabled]="isSubmittingAdmit">
        <i class="ri-check-line" *ngIf="!isSubmittingAdmit"></i>
        {{ isSubmittingAdmit ? ('admissionEnquiryPage.admitting' | translate) : ('admissionEnquiryPage.admitStudent' | translate) }}
      </button>
    </div>
  </div>

  <div class="ne-admit-confirm-body" *ngIf="admittingEnquiry && showAdmitConfirm">
    <div class="ne-admit-confirm-icon"><i class="ri-alert-line"></i></div>
    <h4 class="ne-admit-confirm-title">{{ 'admissionEnquiryPage.admitQuestion' | translate }} {{ admittingEnquiry.studentName }}?</h4>
    <p class="ne-admit-confirm-text">
      {{ 'admissionEnquiryPage.admitConfirmText' | translate }}
    </p>
  </div>

  <div class="ne-modal-foot" *ngIf="admittingEnquiry && showAdmitConfirm">
    <div class="ne-foot-actions ne-foot-actions-full">
      <button class="ne-btn ne-btn-secondary" type="button" (click)="cancelAdmitConfirm()" [disabled]="isSubmittingAdmit">{{ 'admissionEnquiryPage.goBack' | translate }}</button>
      <button class="ne-btn ne-btn-primary" type="button" (click)="confirmAdmitStudent()" [disabled]="isSubmittingAdmit">
        <i class="ri-check-line" *ngIf="!isSubmittingAdmit"></i>
        {{ isSubmittingAdmit ? ('admissionEnquiryPage.admitting' | translate) : ('admissionEnquiryPage.yesAdmitStudent' | translate) }}
      </button>
    </div>
  </div>
</p-dialog>
